<template>
    <div class="container-bg">
        <!-- 头部 -->
        <LotteryHead :data="data"></LotteryHead>
        <h5 style="text-align: center;">注:开奖结果来源于网络，仅供参考不作为兑奖依据。如有疑问，以官方数据为准。</h5>

        <!-- 专家排名轮播 -->
        <MavinTopSwipe :data="data"></MavinTopSwipe>

        <!-- 上期统计 -->
        <UpIssueSum :z3Count="data.z3Count" :z6Count="data.z6Count" :zhixuanCount="data.zhixuanCount"></UpIssueSum>

        <van-divider dashed :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
            🔽 优选方案 🔽
        </van-divider>
        <van-tabs type="card" class="my-tabs" animated style="margin-right: -16px; margin-left: -5px;">
            <van-tab title="单挑专区">
                <!-- 方案列表 -->
                <CaseListSwipe :areaId="1" :postList="data.dantiaoPostList"></CaseListSwipe>
            </van-tab>
            <van-tab title="大底专区">
                <!-- 方案列表 -->
                <CaseListSwipe :areaId="2" :postList="data.dadiPostList"></CaseListSwipe>
            </van-tab>
            <van-tab title="条件专区">
                <!-- 方案列表 -->
                <CaseListSwipe :areaId="4" :postList="data.tiaojianPostList"></CaseListSwipe>
            </van-tab>
            <van-tab title="综合专区">
                <!-- 方案列表 -->
                <CaseListSwipe :areaId="3" :postList="data.zonghePostList"></CaseListSwipe>
            </van-tab>
        </van-tabs>

        <van-divider style="margin-top: 0px;">我是有底线的</van-divider>
    </div>
</template>

<script>
import LotteryHead from '@/components/LotteryHead'
import MavinTopSwipe from '@/components/MavinTopSwipe'
import CaseListSwipe from '@/components/CaseListSwipe'
import UpIssueSum from '@/components/UpIssueSum'
import { home } from '@/api'
export default {
    name: 'LotteryPage',
    components: { LotteryHead, MavinTopSwipe, CaseListSwipe, UpIssueSum },
    props: ['lotteryId'],
    data() {
        return {
            data: {},
        }
    },
    created() {
        this.load()
    },
    methods: {
        // 获取页面数据
        async load() {
            const data = await home.getLotteryPage(this.lotteryId)
            this.data = data || {}
        },
    }
}
</script>

<style scoped>
/* 控制tab的样式 */
.my-tabs::v-deep.van-tabs--card>.van-tabs__wrap {
    margin-left: -11px;
}
/* .my-tabs::v-deep>div.van-tabs__wrap {
    height: 44px;
} */
.my-tabs::v-deep>div.van-tabs__wrap>.van-tabs__nav {
    background: linear-gradient(to bottom, #F9F0EF 0,
            #F8F0F0 44px);
}

h5 {
    font-size: 9px;
    margin: 10px auto;
    color: #969799;
    line-height: 1.5;
}

.van-row {
    margin-right: 10px;
}
</style>